import { z } from "zod";
import {
  optionalBooleanFromString,
  optionalNullableNonNegativeNumber,
  optionalNonNegativeNumber,
  optionalStringArray,
  trimmedString,
} from "./primitives";
import { entityPrioritySchema } from "./entities";

export const createSlaRuleSchema = z.object({
  name: trimmedString,
  keywords: optionalStringArray.default([]),
  enabled: optionalBooleanFromString.default(true),
  priority: entityPrioritySchema.optional(),
  minAgeHours: optionalNonNegativeNumber.optional(),
  slaHours: optionalNonNegativeNumber.optional(),
});

export const updateSlaRuleSchema = z.object({
  name: trimmedString.optional(),
  keywords: optionalStringArray.optional(),
  enabled: optionalBooleanFromString.optional(),
  priority: z.union([entityPrioritySchema, z.null()]).optional(),
  minAgeHours: optionalNullableNonNegativeNumber.optional(),
  slaHours: optionalNullableNonNegativeNumber.optional(),
});

export type CreateSlaRulePayload = z.infer<typeof createSlaRuleSchema>;
export type UpdateSlaRulePayload = z.infer<typeof updateSlaRuleSchema>;
